<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 16:40:15
 * @LastEditTime: 2020-09-09 11:22:44
 * @Description: 创建试卷操作栏
 -->
<template>
  <div class="create-action-bar">
    <pss-button
      text="返回" @on-click="clickCanelBtnHandler" />
    <pss-button
      v-if="jumpBtnShow"
      :disabled="current === 0 && stepOneNextBtnEnable"
      text="跳过" @on-click="clickJumpBtnHandler" />
    <pss-button
      v-if="prevBtnShow"
      text="上一步" @on-click="clickPrevBtnHandler" />
    <pss-button
      v-if="nextBtnShow"
      :disabled="current === 0 && !stepOneNextBtnEnable"
      text="下一步" @on-click="clickNextBtnHandler" />
    <pss-button
      v-if="doneBtnShow"
      text="完成" @on-click="clickDoneBtnHandler" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CreateActionBar',
  props: {
    current: { type: Number, required: true },
    examId: { type: [Number, String], reuqired: true },
    stepOneNextBtnEnable: { type: Boolean, required: true },
  },
  computed: {
    ...mapGetters({
      paperName: 'createPaperStore/paperName',
      addBigQuestionRule: 'createPaperStore/addBigQuestionRule',
      bigQuestions: 'createPaperStore/bigQuestions',
      examTime: 'createPaperStore/examTime',
      examPassScore: 'createPaperStore/examPassScore',
      examObjectList: 'createPaperStore/examObjectList',
    }),
    jumpBtnShow() {
      return this.current === 0;
    },
    prevBtnShow() {
      return this.current > 0 && this.current < 3;
    },
    nextBtnShow() {
      return this.current >= 0 && this.current < 2;
    },
    doneBtnShow() {
      return this.current === 2;
    },
  },
  methods: {
    ...mapActions({
      setPaperId: 'createPaperStore/invokeSetPaperId',
      setPaperName: 'createPaperStore/invokeSetPaperName',
      setBigQuestions: 'createPaperStore/invokeSetBigQuestions',
      setExamTime: 'createPaperStore/invokeSetExamTime',
      setExamPassScore: 'createPaperStore/invokeSetExamPassScore',
    }),
    /**
     * 点击跳过按钮处理函数
     */
    clickJumpBtnHandler() {
      switch (this.current) {
        case 0:
          this.requestUploadRequireQuestionAndSetting();
          break;
        default:
          break;
      }
    },
    /**
     * 点击上一步按钮处理函数
     */
    clickPrevBtnHandler() {
      if (this.current === 1) {
        const flag = window.confirm('返回上一步将不会保留任何操作');

        if (flag) {
          this.setBigQuestions({ bigQuestions: [] });
          this.prev();
        }
      } else if (this.current === 2) {
        const flag = window.confirm('返回上一步将不会保留考试时长和及格分数');

        if (flag) {
          this.setExamTime({ examTime: 0 });
          this.setExamPassScore({ examPassScore: 0 });
          this.prev();
        }
      } else {
        this.prev();
      }
    },
    /**
     * 点击下一步按钮处理函数
     */
    clickNextBtnHandler() {
      if (this.current === 1) {
        let scoreFlag = true;

        this.bigQuestions.forEach((item) => {
          if (item.score === 0) {
            scoreFlag = false;
            // eslint-disable-next-line no-useless-return
            return;
          }
        });

        if (this.bigQuestions.length === 0) {
          alert('没有添加任何题目');
        } else if (!scoreFlag) {
          alert('未设置大类分数');
        } else {
          this.next();
        }
      } else {
        this.next();
      }
    },
    /**
     * 点击完成按钮处理函数
     */
    clickDoneBtnHandler() {
      if (!this.examTime) {
        alert('未设置考试时间');
        return;
      }

      if (!this.examPassScore) {
        alert('未设置考试通过分数');
        return;
      }

      if (this.examObjectList.length === 0) {
        alert('未添加考试对象');
        return;
      }

      this.$emit('done-paper-setting');
    },
    /**
     * 点击返回按钮处理函数
     */
    clickCanelBtnHandler() {
      if (window.confirm('创建试卷未完成，确认返回？')) {
        window.location.href = document.referrer;
      }
    },
    /**
     * 跳转到上一步
     */
    prev() {
      this.$emit('prev');
    },
    /**
     * 跳转到下一步
     */
    next() {
      this.$emit('next');
    },
    /**
     * 请求上传必考题并设置
     */
    requestUploadRequireQuestionAndSetting() {
      this.requestUploadRequireQuestion()
        .then((result) => {
          this.setPaperId({ paperId: result.paper.id });
          this.setPaperName({ paperName: result.paper.name });
          this.next();
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求上传必考题
     */
    requestUploadRequireQuestion() {
      const params = {
        examId: this.examId,
        paperName: this.paperName,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateRequireQuestion(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.create-action-bar {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;

  > a {
    margin-right: 36px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
